import { ResourceCategory } from './../builders/resource_category_builder';
import { IResourceCategoriesDatasource } from './../datasources/resource_categories_datasource';
import { IDefineCommand, IQueryMediator, ICommand, IQuery, key } from 'core-ts-types';

angular
  .module('capability-ng-resources')
  .factory(
    'selectResourceCategoryCommand',
    (
      defineCommand: IDefineCommand,
      QueryMediator: IQueryMediator,
      ngResourceCategoriesDatasource: IResourceCategoriesDatasource
    ): ICommand => {
      return defineCommand(
        'selectResourceCategoryCommand',
        (deferred: ng.IDeferred<IQuery[]>, selectedCategory: ResourceCategory): void => {
          ngResourceCategoriesDatasource.rewrite((source) => {
            return _.each(source, (resourceCategory) => {
              resourceCategory.isSelected = false;
            });
          });

          ngResourceCategoriesDatasource.model.selected = selectedCategory.id;
          _.first(ngResourceCategoriesDatasource.cursor<ResourceCategory>([selectedCategory.id])).isSelected = true;
          deferred.resolve(QueryMediator.runQueries(ngResourceCategoriesDatasource));
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/lib/resources/commands/select_resource_category_command.ts